import { createFileRoute } from '@tanstack/react-router'
import Webhook from 'Administration/components/system/Webhook'

export const Route = createFileRoute('/administration/integrations/_webhooks/webhook/')({
    component: Webhook,
})
